import React, { useEffect } from "react";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import {
  profileItems,
  companyItems,
  notificationPreferences,
} from "../../../utils/Data/dataTexts";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import Tooltip from "@material-ui/core/Tooltip";
import LoadingIndicator from "../../../utils/LoadingIndicator/LoadingIndicator";
import axios from "../../../utils/Axios/axiosProxy";
import Heading from "../../../components/Heading/Heading";
import UserInput from "../../../components/UserInput/UserInput";
import Switch from "../../../components/Switch/Switch.jsx";
import EmblemColor from "../../../assets/Icons/emblem-color.png";
import { checkFilled } from "../../../utils/Functions/functions";
import { UserDashboardContext } from "../UserDashboard";
import { withTranslation } from "react-i18next";
import i18n from "../../../utils/LanguageSelector/i18n";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function UserProfile({ ...props }) {
  const [open, setOpen] = React.useState(false);
  const [updated, setUpdated] = React.useState(true);
  const [alertMessage, setAlertMessage] = React.useState("");
  const [userAccount, setUserAccount] = React.useState({});
  const [loading, setLoading] = React.useState(true);

  const dashboardContext = React.useContext(UserDashboardContext);

  useEffect(() => {
    setUserAccount(props.userAccount);
    setLoading(false);
  }, [props.userAccount, loading]);

  const updateAccount = (data) => {
    if (!updated) {
      axios
        .patch("/api/account/update", JSON.stringify(data), {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("JWT")}`,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          console.log("AXIOS RESPONSE: ", response.statusText);
          setAlertMessage("Data has been succesfully updated");
          setOpen(true);
          setUpdated(true);
          dashboardContext.getUserOrdersMessagesFromDB(
            localStorage.getItem("JWT")
          );
        })
        .catch((error) => {
          console.log("AXIOS ERROR: ", error.response.data);
        })
        .catch((error) => console.log("submitToDB error", error));
    }
  };
  const handleChange = (event) => {
    let value = event.target.value;
    if (event.target.id === "email") {
      value = value.toLowerCase();
    }
    if (updated) {
      setUpdated(false);
    }
    setUserAccount({ ...userAccount, [event.target.id]: value });
  };
  const handleCheck = (event) => {
    if (updated) {
      setUpdated(false);
    }
    setUserAccount({
      ...userAccount,
      notifications: {
        ...userAccount.notifications,
        [event.target.id]: event.target.checked,
      },
    });
  };
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  return (
    <div className="DashboardContent BoxShadow" style={{ padding: 0 }}>
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={handleClose}
        style={{ width: "100%" }}
      >
        <Alert
          onClose={handleClose}
          severity="success"
          style={{ width: "50%" }}
        >
          {alertMessage}
        </Alert>
      </Snackbar>
      {loading ? (
        <LoadingIndicator />
      ) : (
        <>
          {checkFilled(userAccount, companyItems) ? (
            <></>
          ) : (
            <h2 className="ProfileText">{i18n.t("general.filloutdata")}</h2>
          )}
          <Heading
            title={i18n.t("dashboardmenu.profile")}
            className="ToreaBay Save"
            button={true}
            titleB={i18n.t("general.savechanges")}
            onClick={() => updateAccount(userAccount)}
          />
          <div className="UserInfoContainer">
            {profileItems.map((item, i) => {
              return (
                <UserInput
                  key={i}
                  name={item.label}
                  id={item.id}
                  value={userAccount[item.id]}
                  onChange={(event) => handleChange(event)}
                />
              );
            })}
          </div>
          <Heading
            title={i18n.t("general.companylabel")}
            className="ToreaBay Save"
            button={true}
            titleB={i18n.t("general.savechanges")}
            onClick={() => updateAccount(userAccount)}
          />
          <div className="UserInfoContainer">
            <img
              src={EmblemColor}
              alt="emblem"
              style={{ width: "64px", height: "64px", marginBottom: "16px" }}
            />
            {companyItems.map((item, i) => {
              return (
                <UserInput
                  key={i}
                  name={item.label}
                  id={item.id}
                  value={userAccount[item.id]}
                  onChange={(event) => handleChange(event)}
                />
              );
            })}
          </div>
          {/*           <Heading
            title="My addresses"
            className="ToreaBay Save"
            button={true}
            titleB="Save changes"
            onClick={() => updateAccount(userAccount)}
          />
          <div className="AddressesContainer">
            <p className="BottomBorder OrangeFont">From Addresses</p>
            {MyAddresses.map((item, i) => {
              return (
                <div className="NChild">
                  <p>{item.city}</p>
                  <p>{item.address}</p>
                  <p>{item.postcode}</p>
                </div>
              );
            })}
            <p className="BottomBorder OrangeFont">To Addresses</p>
            {MyAddresses.map((item, i) => {
              return (
                <div className="NChild">
                  <p>{item.city}</p>
                  <p>{item.address}</p>
                  <p>{item.postcode}</p>
                </div>
              );
            })}
          </div> */}
          <Heading
            title={
              <span>
                {i18n.t("general.notiprefs")}{" "}
                {
                  <Tooltip
                    title={
                      <span style={{ fontSize: "12px", fontWeight: "bold" }}>
                        {i18n.t("general.notiprefstooltip")}
                      </span>
                    }
                    placement="top"
                  >
                    <HelpOutlineIcon
                      style={{ fontSize: "20px", cursor: "pointer" }}
                    />
                  </Tooltip>
                }
              </span>
            }
            className="ToreaBay Save"
            button={true}
            titleB={i18n.t("general.savechanges")}
            onClick={() => updateAccount(userAccount)}
          />
          <div>
            {notificationPreferences.map((item, i) => {
              return (
                <div key={i} className="NotiPref NChild">
                  <Switch
                    label={item.label}
                    name={item.label}
                    id={item.id}
                    word1="On"
                    word2="Off"
                    checked={userAccount.notifications[item.id]}
                    onChange={(event) => handleCheck(event)}
                  />
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}

export default withTranslation()(UserProfile);
